import React, { useRef, useState } from "react"
import { Button, Col, Image, Overlay, Popover, Row } from "react-bootstrap"


export default function PubliList({ article }) {
  const [show, setShow] = useState(false)
  const [target, setTarget] = useState(null)
  const ref = useRef(null)

  const onClick = (event) => {
    setShow(!show)
    setTarget(event.target)
  }
  const mouseLeave = () => {
    setShow(!show)
  }
  return (
    <div ref={ref} className="div">
      <div className="citationDiv">
        <span className="citationTitle">{article.node.Title} </span>
        <span className="citationAuthors">{article.node.Authors}</span>
        <br/>
        <span className="citationJournal">{article.node.Journal}   {article.node.Date}  </span>
        <span className="citationLinks">
           <br/>
          <span className="pubLink" onClick={onClick} > [PopUp Abstract] </span>
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="pubLink"
          style={{ margin: "15px" }}
          href={article.node.PDF.publicURL}
        >
          {" "}
         [PDF]
        </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="pubLink"
                style={{ margin: "15px" }}
                href={article.node.url}
              >
          [PubMed]
        </a>
          {article.node.Communications1 && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="pubLink"
              style={{ margin: "15px" }}
              href={article.node.Communications1.publicURL}
            >
              Read what they wrote in the press!
            </a>
          )}

          {article.node.Communications2 && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="pubLink"
              style={{ margin: "15px", textAlign: "center" }}
              href={article.node.Communications2.publicURL}
            >
              AND here!
            </a>
          )}
        </span>
      </div>
      <div style={{
        color: "floralWhite",
        textAlign: "center",
        paddingLeft: "60px",
        paddingRight: "60px",
      }}>


        <Overlay
          show={show}
          target={target}
          placement="bottom"
          container={ref.current}
          containerPadding={20}
        >
          <Popover id="popover-contained"
                   style={{
                     maxWidth: "60%",
                     minWidth: "250px",
                     flexDirection: "col",
                     justifyContent: "center",
                     alignItems: "center",
                     backgroundColor: "black",
                     borderColor: "#91CBB7",
                   }}>
            <Popover.Title style={{ backgroundColor: "black", textAlign: "center" }}><p
              className="popoverTitle">{article.node.Title}</p></Popover.Title>
            <Popover.Content>
              <Row xs={1} md={1} lg={2} className="pubRow">
                {article.node.Illustration && (

                  <Col className="pubCol">

                    <Image xs={12} md={6}
                           variant="top"
                           src={article.node.Illustration.publicURL}
                           style={{
                             maxHeight: "300px",
                             borderRadius: "10px",
                             margin: "auto",

                           }}
                    />
                  </Col>
                )}

                <Col xs={12} md={6}>
                  <div className="overflow-auto"
                       style={{
                         paddingTop: "12px",
                         maxHeight: "300px",
                         paddingBottom: "12px",
                         fontSize: 13,
                         textAlign: "justify",
                         color: "floralWhite",
                       }}>{article.node.Abstract}
                  </div>
                </Col>
              </Row>
              <Row xs={1} md={1} lg={2} className="pubRow">
                <Button
                  onClick={mouseLeave}
                  variant="link"
                  style={{
                    alignSelf: "center",
                    color: "#91CBB7",
                    marginBottom: "15px",
                  }}
                >
                  Close
                </Button>
              </Row>
            </Popover.Content>
          </Popover>
        </Overlay>
      </div>
    </div>

  )
}

